import styled from 'styled-components';

const BasicDivHeight100 = styled.div`
  margin-top: -3px;
  overflow: auto;
  height: 100%;
`;

export default BasicDivHeight100;
